import { render, staticRenderFns } from "./BatchJobDetailCrawl.vue?vue&type=template&id=464c6630&scoped=true&"
import script from "./BatchJobDetailCrawl.vue?vue&type=script&lang=js&"
export * from "./BatchJobDetailCrawl.vue?vue&type=script&lang=js&"
import style0 from "./BatchJobDetailCrawl.vue?vue&type=style&index=0&id=464c6630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c6630",
  null
  
)

export default component.exports